module.exports = __webpack_public_path__ + "img/ctrl-xx-1.26dbbf2d.svg";